import api from "@/api/http.js";
import $ from "jquery";

const host = process.env.BASE_HOST;

// var host = '/vmall'
console.log(host)

export default {


  // 获取公告详情
  GetCmsnewDetail(id){
    return api.post(host+`/home/GetCmsnewDetail`,{
      id:id
    });
  },

  // 获取公告列表
  GetCmsnewList(num){
    return api.post(host+`/home/GetCmsnewList`,{
      top:num?num:10,
    });
  },

  // 获取广告列表
  GetGWList(){
    return api.post(host+`/home/GetGWList`);
  },

  // 好友代付时微信支付调用的接口
  ToKenWxPay(ordercode,token){
    return api.get(host+`/api/pay/ToKenWxPay`,{
      params: {
        ordercode:ordercode,
        token:token
      }
    });
  },

  // 获取微信JSSDK参数
  JsConfig(URL) {
    return api.get(host+`/api/Common/JsConfig`,{
      params: {
        URL:URL
      }
    });
  },

  //获取用户状态
  GetMemberStatus(arg) {
    return api.get(host+`/api/Member/GetMemberStatus`);
  },

  //精品推荐
  getBestItems(arg) {
    return api.get(host+`/api/Product/GetProductInfo`, {
      params: {
        pcodes: arg
      }
    });
  },

  //分类列表
  getClassList(arg) {
    return api.get(host+`/api/List/Index`, {
      params: {
        code: arg.code ? arg.code : "",
        sortkey: arg.sortkey,
        sort: arg.sort,
        index: arg.index,
        size: arg.size,
        ActivityType:arg.ActivityType
      }
    });
  },
  // 删除收藏记录
  removeFavorite(arg) {
    return api.post(host+`/api/Member/RemoveSelectedProductFavorite`, {
      PCodes: arg.join()
    });
  },
  // 获取搜索列表
  getSearchList(arg) {
    return api.get(host+`/api/Search/Index`, {
      params: {
        keyword: arg.keyword,
        index: arg.index,
        size: arg.size
      }
    });
  },
  // 商品详情
  getProDetail(arg) {
    return api.get(host+`/api/product/detail`, {
      params: {
        pcode: arg
      }
    });
  },
  // 缺货表单
  regForm(obj) {
    return api.post(host+`/api/Product/ShortageRegistration`, {
      Mobile: obj.proTel,
      PCode: obj.proID,
      Num: obj.proNum,
      Notes: obj.protxt
    });
  },
  // 获取购物车数量
  cartNum() {
    return api.get(host+`/api/ShoppingCart/GetShoppingCartNum`);
  },
  //商品加入购物车
  addCart(arg) {
    return api.post(host+`/api/ShoppingCart/AddShoppingCart`, {
      Num: arg.Num,
      PCode: arg.PCode
    });
  },
  // 添加到我的收藏
  addCollect(PCode) {
    return api.post(host+`/api/Member/AddProductFavorite`, {
      PCode
    });
  },
  //移除到我的收藏
  removeCollect(PCode) {
    return api.post(host+`/api/Member/RemoveProductFavorite`, {
      PCode
    });
  },
  //获取收藏列表
  getCollect(arg) {
    return api.get(host+`/api/Member/GetFavoriteList`, {
      params: {
        index: arg.index,
        size: arg.size
      }
    });
  },
  // 用户注册
  signUp(data) {
    return api.post(host+"/api/Member/MobileSignUp", data);
  },

  // 用户登录
  signIn(data) {
    return api.post(host+"/api/Member/LoginBind", data);
  },

  // 获得图片验证码
  getImgCode() {
    return api.get(host+"/home/VerificationCode?w=120&h=40&r=" + Math.random());
  },

  //发送注册验证码
  getVCode(data) {
    return api.post(host+"/home/SendSignUpSMS", $.param(data), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },

  //修改密码
  ModifyPassword(data) {
    return api.post(host+"/api/Member/ModifyPassword", data);
  },
  // 获取订单列表
  getOrderList(type, index, size,kd) {
    return api.get(host+"/api/Member/GetOrderList", {
      params: {
        type: type,
        index: index,
        size: size,
        search:kd
      }
    });
  },

  // 获取订单详情
  getOrderDetail(ordercode,token) {
    return api.get(host+"/api/Member/OrderDetail", {
      params: {
        ordercode: ordercode,
        token:token
      }
    });
  },

  order(ordercode, type) {
    // type:
    // 1 = 取消订单
    // 2 = 删除订单
    // 3 = 确认收货
    // 4 = 再次购买
    switch (type) {
      case 1:
        return api.post(host+"/api/Member/CancelOrder", {
          OrderCode: ordercode
        });
        break;
      case 2:
        return api.post(host+"/api/Member/DeleteOrder", {
          OrderCode: ordercode
        });
        break;
      case 3:
        return api.post(host+"/api/Member/ConfirmReceipt", {
          OrderCode: ordercode
        });
        break;
      case 4:
        return api.post(host+"/api/Member/BuyAgain", {
          OrderCode: ordercode
        });
        break;
    }
  },

  // 获取购物车信息
  getShoppingCart() {
    return api.get(host+"/api/ShoppingCart/GetShoppingCart").then(res => res.data);
  },

  /**
   *取消/勾选购物车产品
   * @param {number} IsCheck 是否选中(选中传1，取消勾选传0)
   * @param {number} PCode 产品编号
   */
  productSelect(dataObj) {
    return api
      .post(host+"/api/ShoppingCart/ProductSelect", dataObj)
      .then(res => res.data);
  },

  // 取消/全选购物车产品
  productSelectAll() {
    return api.post(host+"/api/ShoppingCart/ProductSelectAll").then(res => res.data);
  },

  //修改购物车产品数量
  changeProductAmount(
    pcode /**产品编号 {number}*/,
    num /**修改后数量 {numer}*/
  ) {
    return api
      .post(host+"/api/ShoppingCart/ChangeProductAmount", {
        pcode,
        num
      })
      .then(res => res.data);
  },

  // 删除购物车产品
  deleteShoppingCart(Pcode) {
    return api
      .post(host+"/api/ShoppingCart/DeleteShoppingCart", {
        PCode: Pcode
      })
      .then(res => res.data);
  },

  // 删除购物车选中产品 IsSelect属性
  deleteAllSelect() {
    return api.post(host+"/api/ShoppingCart/DeleteAllSelect").then(res => res.data);
  },

  // 个人中心获取用户信息
  GetMemberInfo() {
    return api.get(host+"/api/Member/GetMemberInfo");
  },
  // 购物车将选中商品加入我的收藏
  collectAllSelect() {
    return api.post(host+"api/ShoppingCart/CollectAllSelect").then(res => res.data);
  },

  // 获取预订单信息
  getOrderInfo() {
    return api.get(host+"api/Order/GetOrderInfo").then(res => res.data);
  },

  // 上传图片
  uploadImg(formData) {
    return api.post(host+"/api/Common/UploadImg", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  // 添加认证信息
  AddAuthInfo(data) {
    return api.post(host+"/api/Member/AddAuthInfo", data, {
      // headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded'
      // }
    });
  },
  // 获取用户认证信息
  getAuthInfo() {
    return api.get(host+"/api/Member/GetAuthInfo").then(res => res.data);
  },

  /**
   * 生成订单
   * @param {number} PaymentType 支付方式（ 货到付款=1,在线支付=99）
   * @param {number} InvoiceType 发票类型（不开发票=0,增值税普通发票_电子发票=1,增值税普通发票_纸质发票=2,增值税专用发票_电子发票=3 增值税专用发票_纸质发票=4）
   * @param {number} DeliveryId 收货地址编号
   * @param {string} OrderNote 订单备注
   */
  addOrder(dataObj) {
    return api.post(host+"/api/Order/AddOrder", dataObj).then(res => res.data);
  },

  /**
   * 获取运费信息（单位：分）
   * @param {number} sum 订单金额（分）
   * @param {string} region 收货地址区域（例：440000）
   */
  getPostFee(sum, region) {
    return api
      .get(host+`/api/Order/GetPostFeeInfo?sum=${sum}&region=${region}`)
      .then(res => res.data);
  },

  //获取支付信息 OrderCode 	订单号
  getPayInfo(OrderCode) {
    return api
      .get(host+"/api/Pay/GetPayInfo", {
        params: {
          OrderCode
        }
      })
      .then(res => res.data);
  },

  // 微信支付接口数据  OrderCode 	订单号
  wxPay(OrderCode,token) {
    return api
      .get(host+"/api/Pay/WxPay", {
        params: {
          OrderCode,
          token:token,
        }
      })
      .then(res => res.data);
  },

  // 发送找回密码验证码
  SendFindPswdSMS(data) {
    return api.post(host+"/home/SendFindPswdSMS", $.param(data), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },

  // 验证账号手机号
  CheckAccountMobile(vcode) {
    return api.get(host+"/api/Member/CheckAccountMobile", {
      params: {
        vcode: vcode
      }
    });
  },

  // 验证营业执照编号是否重复
  CheckBusinessLicense(license) {
    return api.get(host+"/api/Member/CheckBusinessLicense", {
      params: {
        license: license
      }
    });
  },

  // 发送修改密码验证码
  SendModifyPswdSMS(data) {
    return api.post(host+"/home/SendModifyPswdSMS", $.param(data), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },

  //发送修改手机号码验证码
  SendModifyMobileSMS(data) {
    return api.post(host+"/home/SendModifyMobileSMS", $.param(data), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },

  //发送新手机号验证码
  SendModifyMobileSMS2(data) {
    return api.post(host+"/home/SendModifyMobileSMS2", $.param(data), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  },

  // 修改手机号
  ModifyMobile(data) {
    return api.post(host+"/api/Member/ModifyMobile", data);
  },

  // 找回密码
  ForgotPassword(data) {
    return api.post(host+"/api/Member/ForgotPassword", data);
  },

    // 查看订单物流 type = 物流类型（不同平台/顺丰or邮政） OrderCode = 订单号
    GetLogistics(type,OrderCode){
        return api.get(host+"/api/Member/GetLogistics", {
            params: {
                type:type,
                code:OrderCode
            }
        });
    },

    // 小雨点
    //获取授信H5地址
    GetCreditH5Url(){
      return api.get(host+`/api/Pay/GetCreditH5Url`);
    },
    //获取授信信息
    GetCreditInfo(){
      return api.get(host+`/api/XYDFront/GetCreditInfo`);
    },

    //获取借款列表
    GetLoanList(){
      return api.get(host+`/api//XYDFront/GetLoanList`);
    },
    //获取放款订单详情
    GetLoanInfo(ID) {
      return api.get(host+`/api/XYDFront/GetLoanInfo`, {
        params: {
          id: ID
        }
      });
    },
    //获取还款计划列表
    GetLoanPlanList(ID) {
      return api.get(host+`/api/XYDFront/GetLoanPlanList`, {
        params: {
          loanId: ID
        }
      });
    },
    //搜索
    search(ID) {
      return api.get(host+`/api/XYDFront/GetLoanList`, {
        params: {
          orderCode: ID
        }
      });
    },
    // 是否启用小雨点
    IsEnable(){
      return api.get(host+`/api/XYDFront/IsEnable`);
    },
    GetLoanH5Url(orderCode){
      return api.get(host+`/api/Pay/GetLoanH5Url`, {
        params: {
          orderCode: orderCode
        }
      });
    },

    // 个人中心页面
    GetUserCenterH5(){
      return api.get(host+`/api/XYDFront/GetUserCenterH5`);
    },
};



// WEBPACK FOOTER //
// ./src/api/api.js